export default "__VITE_ASSET__uguImPdL__"